import { boardProxy } from './index';
// proxy/board/2.0/

/* [ 공지사항 ] */
// 게시판속성정보조회
function getBoardDefOption(params) {
  return boardProxy.get('def/info', { params });
}

// 공지사항 목록조회
function getBoardList(params) {
  return boardProxy.get('post/list', { params });
}

// 공지사항 상세조회
function getBoardDetail(params) {
  return boardProxy.get('post/detail', { params });
}

export { getBoardDefOption, getBoardList, getBoardDetail };
